import { createContext } from 'react';

export type UserContextType = {
  email: string;
  name: string;
  fullname: string;
  userId: number;
  //  THIS is a completely temporary values for the roles. I added them to be able to distinguish between admin and caregiver for the notifications panel.
  isAdmin: boolean;
  isCaregiver: boolean;
  // Office Administrator: full admin access EXCEPT the billing module.
  isOfficeAdmin: boolean;
  // Doctor: a clinical-oversight persona scoped to their own patients.
  isDoctor: boolean;
};

export type AuthContextProps = {
  auth: string | null;
  removeAuthentication: () => void;
  logout: () => void;
  // True once the auth flow has finished parsing the token and resolving the
  // user's roles, so callers can wait for auth to settle before rendering.
  isInitialized: boolean;
  user: UserContextType;
  // Persist the current user's chosen language to their account (best-effort).
  persistLocale: (locale: string) => void;
};

export const defaultUser: UserContextType = {
  email: '',
  name: '',
  fullname: '',
  userId: -1,
  isAdmin: false,
  isCaregiver: false,
  isOfficeAdmin: false,
  isDoctor: false,
};

export const initAuthContextPropsState: AuthContextProps = {
  auth: '',
  removeAuthentication: () => {},
  logout: () => {},
  isInitialized: false,
  user: defaultUser,
  persistLocale: () => {},
};

export const AuthContext = createContext<AuthContextProps>(initAuthContextPropsState);

AuthContext.displayName = 'Auth';
